import request from '@/utils/request'

const chechangOneClickSync = {
  communitySelect(query) {
    return request({ url: '/chechang/one-click-sync/communitySelect', method: 'get', params: query })
  },
  vehicleList(query) {
    return request({ url: '/chechang/one-click-sync/vehicleList', method: 'get', params: query })
  },
  sync(data) {
    return request({ url: '/chechang/one-click-sync/sync', method: 'post', data })
  },
  syncProgress(query) {
    return request({ url: '/chechang/one-click-sync/sync/progress', method: 'get', params: query })
  },
  syncHistory(query) {
    return request({ url: '/chechang/one-click-sync/sync/history', method: 'get', params: query })
  }
}

export default chechangOneClickSync
